import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutAlignRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"layout-align-right"} maskId="square-filled-radius-0-stroke-1-IconLayoutAlignRight"><path fillRule="evenodd" clipRule="evenodd" d="M3 21V3H21V21H3ZM16 17H17V7H16V17Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconLayoutAlignRight;
